export * from './reservation.model';
export * from './user.model';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/models/index.ts